var map = {
	"./Alexey-Belovs.jpg": "7406",
	"./Alexey-Belovs.png": "f316",
	"./Andreas-Bjorklund.jpg": "d0f6",
	"./Carli-Deysel.png": "32e8",
	"./HP-bg-image-min.jpg": "7a8e",
	"./Icon Ad hoc.svg": "658a",
	"./Icon Advisors.svg": "6d80",
	"./Icon Analyse.svg": "87d1",
	"./Icon Analysts.svg": "2b1d",
	"./Icon Benchmarking.svg": "f6ad",
	"./Icon Board Members.svg": "1a60",
	"./Icon Corporate Executives.svg": "84c3",
	"./Icon Documents.svg": "d22c",
	"./Icon Duplication.svg": "7e95",
	"./Icon Fact Base.svg": "6564",
	"./Icon Investors.svg": "bd86",
	"./Icon Knowledge Base.svg": "9c8c",
	"./Icon Opportunity prioritization.svg": "a456",
	"./Icon Performance Assessment.svg": "7f9f",
	"./Icon Raw Data.svg": "38e9",
	"./Icon Reliance.svg": "6392",
	"./Icon Software.svg": "006e",
	"./Icon Strategic planning.svg": "15b4",
	"./Icon Target.svg": "6932",
	"./Icon User-friendly.svg": "9510",
	"./Idriss-Soumare.jpg": "1726",
	"./Julien-Demoutiez.jpg": "1b94",
	"./Ksenia-Kanishcheva.jpg": "b90f",
	"./Nikolajs-Precenieks.jpg": "647b",
	"./about-bg-img.jpg": "a6d6",
	"./about-image-min.jpg": "8121",
	"./hp-bg-img.jpg": "5222",
	"./ipad-min.png": "4e2f",
	"./maps.png": "c7a4",
	"./mktBI-Web-App-4-min.png": "8158",
	"./mktBI-code-2-min.png": "1aa9",
	"./online-data.jpg": "5438"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "892c";